import React from 'react';
import {useSelector} from "react-redux";
import { truncateToTwoDecimals } from "utils/common";
import { useTranslation } from "react-i18next";

const Table = () => {
  const totalPrice = (useSelector(state => state.Feature.priceData)).reduce((sum, item) => sum + item.price, 0);
  const priceData = useSelector(state => state.Feature.priceData);

  const baseUrl = useSelector(state => state.Feature.imageBaseUrl);

  const { t } = useTranslation();
  
  return(
    <>
      <div>
        <div className='cost-estimate'>{t('Cost estimate')}</div>
        <table border="1" className='acp-table'>
          <thead>
            <tr>
              <th>{t('Product')}</th>
              <th>{t('Colour')}</th>
              <th>{t('Quantity')}</th>
              <th>M²</th>
              <th>{t('Price')}</th>
              <th>{t('Total')}</th>
            </tr>
          </thead>
          <tbody>
          {
            priceData.map(item => {
              return (
                <tr>
                  <td>{item.product_name}</td>
                  <td>
                    <div style={{paddingRight:"5px"}}>
                      <img style={{height:"51px", width:"50px"}} src={baseUrl+item.color_image} alt='color'/>
                    </div>
                    {item.color_name}
                  </td>
                  <td>{item?.quantity}</td>
                  <td>{item.m2}</td>
                  <td>{item?.entirePrice}</td>
                  <td>{truncateToTwoDecimals(item.price)}€</td>
                </tr>
              )
            })
          }
          </tbody>
        </table>
      </div>
      <div className='acp-total-price'>
        <div>{t('Total')}:</div>
        <div>€{truncateToTwoDecimals(totalPrice)}</div>
      </div>
    </>
  )
}

export default Table;